"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinleyCustomFunctionsPluginTranslations = exports.FinleyCustomFunctions = void 0;
const hyperformula_1 = require("hyperformula");
const common_1 = require("@finley-technologies/common");
/**
 * Register Hyperformula custom functions
 * https://hyperformula.handsontable.com/guide/custom-functions.html
 *
 * in order to add a custom function, the function name must also be added to
 * the valid functions list {@link validFunctions} in packages/universal/formula-engine/source/validate.ts
 * otherwise it will fail to be recognized as a function
 */
class FinleyCustomFunctions extends hyperformula_1.FunctionPlugin {
    formatUsdCurrency(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('USDOLLAR'), (amount) => {
            return `${common_1.utils.numberToCurrencyWithSymbol({
                number: amount,
            })}`;
        });
    }
}
exports.FinleyCustomFunctions = FinleyCustomFunctions;
FinleyCustomFunctions.implementedFunctions = {
    USDOLLAR: {
        method: 'formatUsdCurrency',
        parameters: [{ argumentType: hyperformula_1.FunctionArgumentType.NUMBER }],
    },
};
exports.FinleyCustomFunctionsPluginTranslations = {
    enGB: {
        USDOLLAR: 'USDOLLAR',
    },
    enUS: {
        USDOLLAR: 'USDOLLAR',
    },
};
//# sourceMappingURL=customFunctions.js.map